import { chakra, EloIcon } from '@plurall/elo-v3';

import {
  activityCardBottomLeftRecipe,
  activityCardDescriptionRecipe,
  activityCardHeroRecipe,
  activityCardImageRecipe,
  activityCardMetaIconRecipe,
  activityCardMetaItemContentRecipe,
  activityCardMetaItemDescriptionRecipe,
  activityCardMetaItemRecipe,
  activityCardMetaRecipe,
  activityCardMetaTextRecipe,
  activityCardRecipe,
  activityCardTitleLinkRecipe,
  activityCardTitleRecipe,
  activityCardTopRightRecipe,
} from './activity-card.recipe';

export const ActivityCardRootFactory = chakra('div', activityCardRecipe);
export const ActivityCardHeroFactory = chakra('div', activityCardHeroRecipe);
export const ActivityCardImageFactory = chakra('img', activityCardImageRecipe);
export const ActivityCardBottomLeftFactory = chakra('div', activityCardBottomLeftRecipe);
export const ActivityCardTopRightFactory = chakra('div', activityCardTopRightRecipe);
export const ActivityCardTitleFactory = chakra('h3', activityCardTitleRecipe);
export const ActivityCardTitleLinkFactory = chakra('a', activityCardTitleLinkRecipe);
export const ActivityCardDescriptionFactory = chakra('p', activityCardDescriptionRecipe);
export const ActivityCardMetaFactory = chakra('div', activityCardMetaRecipe);
export const ActivityCardMetaItemFactory = chakra('div', activityCardMetaItemRecipe);
export const ActivityCardMetaItemContentFactory = chakra('div', activityCardMetaItemContentRecipe);
export const ActivityCardMetaItemDescriptionFactory = chakra('div', activityCardMetaItemDescriptionRecipe);
export const ActivityCardMetaIconFactory = chakra(EloIcon, activityCardMetaIconRecipe);
export const ActivityCardMetaTextFactory = chakra('p', activityCardMetaTextRecipe);
